import { makeStyles, Theme } from "@material-ui/core";
import clsx from "clsx";
import React, { ReactNode } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    height: 48,
    width: "100%",
    borderRadius: 5,
    justifyContent: "center",
    outline: "none",
    cursor: "pointer",
    border: "1px solid rgb(153, 153, 153)",
    background: "#fff",
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "var(--regular-font)",
    "&:hover": {
      boxShadow: "0px 1px 12px 0px rgba(0, 0, 0, 0.12)",
    },
    "& svg": {
      verticalAlign: "middle",
    },
    "& iframe": {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transform: "scale(1.5)",
    },
  },
  iconWrapper: {
    position: "absolute",
    left: 28,
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  hidden: {
    opacity: 0.0001,
    position: "absolute",
  },
}));

interface Props {
  className?: string;
  icon: ReactNode;
  text: ReactNode;
  onClick: () => void;
  children?: ReactNode;
}

export const BaseSocialButton = ({ className, text, icon, onClick, children }: Props) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} onClick={onClick}>
      <div className={classes.iconWrapper}>{icon}</div>
      {text}
      <div className={classes.hidden}>{children}</div>
    </div>
  );
};
